"use client";

export { default } from "@/components/error-tracking/RouteError";
